package kz.dentalcrm.app.data.network.response_model.employees

import kotlinx.serialization.Serializable

@Serializable
data class Account(
    val created_at: String? = null,
    val email: String? = null,
    val email_verified_at: String? = null,
    val id: Int? = null,
    val role_id: Int? = null,
    val updated_at: String? = null,
    val permissions: List<kz.dentalcrm.app.data.network.response_model.permissions.Permission>? = null
)